<template>
  <div id="page-wrapper" style="height:100%">
      <section id="content" style="height:100%">
      <div id="frame">
        <div id="sidepanel">
          <div id="search">
            <label for=""><i class="fa fa-search" aria-hidden="true"></i></label>
            <input type="text" :placeholder="$t('crm.my-client.ph')" />
          </div>
          <div id="contacts">
            <ul>
              <li class="contact" v-for="c in client.my">
                <Company :c="c" @click.native="changeCompany(c)" />
              </li>
            </ul>
          </div>
          <div id="bottom-bar">
            <button id="addcontact"><i class="fa fa-address-card-o fa-fw" aria-hidden="true"></i> <span>{{ $t('crm.my-client.my') }}</span></button>
            <button id="settings"><i class="fa fa-diamond fa-fw" aria-hidden="true"></i> <span>{{ $t('crm.my-client.all') }}</span></button>
          </div>
        </div>
        <div class="content">
          <div class="contact-profile">
            <img src="assets/img/user-5.jpg" alt="" />
            <p></p>
            <div class="social-media">
              <i class="fa fa-user" aria-hidden="true"></i>
              <i class="fa fa-bars" aria-hidden="true"></i>
               <i class="fa fa-commenting-o" aria-hidden="true"></i>
            </div>
          </div>
          <div class="messages">
            <CompanyInfo :c="currentClient" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Company from '@/components/crm/Company.vue'
import CompanyInfo from '@/components/crm/CompanyInfo.vue'
import { Loading } from 'element-ui'

export default {
  name: 'Client-List',
  components: {
    Company,
    CompanyInfo
  },
  data: function() {
  return {
    client: null,
    currentClient: null
  }
  },
  computed: {
    userId: function() {
      return localStorage.getItem('token')
    }
  },
  methods: {
    changeCompany: function(c) {
      console.log(c)
      this.currentClient = c
    },
    loadData: function() {
      let that = this,
          query = 'userId=' + this.userId
      this.$http.get(this.API3_PREFIX + 'account_list?' + query).then(function (response) {
    that.client = response.data
    if (that.client.my.length > 0)
      that.currentClient = that.client.my[0]
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>